module.exports = __webpack_public_path__ + "static/media/img_process6.9162a1db.png";